import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const BedOutline = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M24.8 13.5172V10.2069C24.8 8.98806 23.815 8 22.6 8H9.4C8.18497 8 7.2 8.98806 7.2 10.2069V13.5172M7.2 21.7931V24M24.8 21.7931V24M9.95 13.5172V11.8621C9.95 11.2527 10.4425 10.7586 11.05 10.7586H13.25C13.8575 10.7586 14.35 11.2527 14.35 11.8621V13.5172M17.65 13.5172V11.8621C17.65 11.2527 18.1425 10.7586 18.75 10.7586H20.95C21.5575 10.7586 22.05 11.2527 22.05 11.8621V13.5172M6.1 21.2414H25.9C26.5075 21.2414 27 20.7473 27 20.1379V16.8276C27 16.2182 26.5075 15.7241 25.9 15.7241H6.1C5.49249 15.7241 5 16.2182 5 16.8276V20.1379C5 20.7473 5.49249 21.2414 6.1 21.2414Z" strokeLinecap="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper strokeWidth={1} {...props} variant="outline" viewBox="0 0 32 32">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { BedOutline };